import {
  AgGridEvent,
  Events,
  GridApi,
  IStatusPanelComp,
  IStatusPanelParams,
} from '@ag-grid-community/core'
import { loadTemplate } from '@ag-grid-community/core/dist/cjs/utils/dom'
import { GenericTransaction, GenericTxSummary } from './generic-transaction'
import { debounce } from 'lodash-es'

export abstract class TransactionsStatusBarBase implements IStatusPanelComp {
  protected readonly eGui: HTMLElement
  protected abstract onRowSelectionChanged: (
    selection: GenericTransaction[],
  ) => void
  protected abstract onSelectAllTransactions: (
    txDataSummary: GenericTxSummary,
  ) => void

  /**
   * @internal
   */
  readonly baseOnSelectionChangedListener = debounce(
    (ev: AgGridEvent) => this.baseOnSelectionChanged(ev),
    100,
    { maxWait: 250, trailing: true },
  ).bind(this)

  private params!: IStatusPanelParams

  constructor(template: string) {
    this.eGui = loadTemplate(template)
  }

  init(params: IStatusPanelParams) {
    this.params = params
    params.api.addEventListener(
      Events.EVENT_SELECTION_CHANGED,
      this.baseOnSelectionChangedListener,
    )
  }

  getGui() {
    this.setEmpty()
    return this.eGui
  }

  destroy() {
    this.params.api.removeEventListener(
      Events.EVENT_SELECTION_CHANGED,
      this.baseOnSelectionChangedListener,
    )
  }

  /**
   * @internal
   * @param event
   */
  baseOnSelectionChanged(event: AgGridEvent) {
    const context:
      | {
          isSelectAllRowsEnabled?: () => boolean
          summaryData?: () => { rowCount: number }
        }
      | undefined = this.params.context

    if (
      context != null &&
      context.isSelectAllRowsEnabled != null &&
      context.isSelectAllRowsEnabled() &&
      context.summaryData != null
    ) {
      this.onSelectAllTransactions(context.summaryData())
    } else {
      this.onRowSelectionChanged(event.api.getSelectedRows())
    }
  }

  protected setEmpty(selectedRows?: unknown[]) {
    const isEmpty =
      (selectedRows ?? this.params.api.getSelectedRows()).length === 0
    if (isEmpty) {
      this.eGui
        .getElementsByClassName('value-container')?.[0]
        ?.classList.add('empty')
    } else {
      this.eGui
        .getElementsByClassName('value-container')?.[0]
        ?.classList.remove('empty')
    }
  }
}
